import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataUser } from '../../../../models/generar_pedido/DataUser';
import { LoginService } from '../../../../services/login/login.service';
import { environment } from '../../../../../environments/environment';
import { EmpresaService } from '../../../../services/Empresa/Empresa.service';

@Injectable({
  providedIn: 'root'
})
export class NotificacionesService {
  empresaId: number;

  constructor(
    private http: HttpClient,
    private login: LoginService,
    private empresaService: EmpresaService
  ) {
    this.empresaService.empresaId$.subscribe(id => {
      this.empresaId = id;
    });
  }

  /*Codigo de los kabikCoins mantiene actualizado cuantos puntos kabiCoins tiene */
  public kabikCoins = new BehaviorSubject<number>(0); //Requiere un valor inicial y emite su valor actual a los nuevos suscriptores.
  kabikCoins$ = this.kabikCoins.asObservable();

  public legends = new BehaviorSubject<any>([]);
  legends$ = this.legends.asObservable();

  private apiUrl = environment.apiUrl;

  public getNotificacionPuntosKabikCoins = () => {
    const dataUser: DataUser = this.login.getDataClientePedido();
    const dataQuery = {
      option: 'puntosKabiCoin',
      empresa: this.empresaId,
      clienteId: dataUser.client_number, // 576 //dataUser.client_numberPii
    };
    return this.http
      .post<any>(
        this.apiUrl + 'account/kabikCoins.php',
        dataQuery
      )
      .pipe(
        map((response) => {
          console.log("respuesta kabicoins", response)
          this.notificaPuntosKb$(response.kabikCoins);
          this.legends.next(response.legends);
          return response;
        })
      );
  };

  public cleanKabikCoins$ = () => {
    this.kabikCoins.next(0);
  }

  private notificaPuntosKb$ = (puntosKb: number) => {

    this.kabikCoins.next(puntosKb);
  }
}
